<div class="container">
    <div class="container-filters col-12 row">
        <div class="form-group row col-md-5">
            <label class="col-form-label"><strong>{{'Estado'}}</strong></label>
            <ng-select [ngClass]="'ng-select'" bindLabel="name" bindValue="id" [clearable]="false"
                [placeholder]="filtroEstado? '' :'Seleccione una opción'" (change)='changeFilterState($event)'
                [items]="itemsEstados" [(ngModel)]="filtroEstado" class="ng-select">
            </ng-select>
        </div>
    </div>


    <div class="row">
        <ngx-datatable #table class="datatable" [rows]="datosEmails" [columns]="columns" columnMode="standard"
            rowHeight="auto" [headerHeight]="50" [footerHeight]="50">

            <ngx-datatable-column *ngFor="let column of columns" [name]="column.name" class="datatable-column"
                [prop]="column.prop" [flexGrow]="1" [minWidth]="100">
            </ngx-datatable-column>

            <ngx-datatable-column *ngIf="filtroEstado && filtroEstado === 'estado1'" name="Fecha filtro 1"
                class="datatable-column" prop="" [flexGrow]="1" [minWidth]="100">
                <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
                    <span>{{value.fechaFiltro1}}</span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column *ngIf="filtroEstado && filtroEstado === 'estado2'" name="Fecha filtro 2"
            class="datatable-column" prop="" [flexGrow]="1" [minWidth]="100">
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
                <span>{{value.fechaFiltro2}}</span>
            </ng-template>
        </ngx-datatable-column>

            <ngx-datatable-column name="Estado de envio" class="datatable-column" prop="" [flexGrow]="1"
                [minWidth]="100">
                <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
                    <img *ngIf="row['deliveryStatus'] === 'sent'" src="assets/iconos/email-sent-icon.png"
                        alt="email-sent-icon" width="30">
                    <img *ngIf="row['deliveryStatus'] !== 'sent'" src="assets/iconos/email-not-sent-icon.png"
                        alt="email-not-sent-icon" width="30">
                </ng-template>
            </ngx-datatable-column>

        </ngx-datatable>
    </div>
</div>